var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"bread-crumbs"},[_c('app-bread-crumbs',{attrs:{"routes":[
      { name: 'login', title: 'Connexion / Inscription' },
      { name: 'myAccountPage', title: 'Mon Compte' },
    ]}}),_c('app-show-my-account')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }